import React from 'react';
import SpinnerSVG from './../assets/puff.svg';

const Spinner = () => {
    return <SpinnerSVG />
}

export default Spinner;